/**
 * Viewport-width hook — single source of truth for "is the user on a phone."
 *
 * Anything narrower than `MOBILE_BREAKPOINT` (768px) is treated as mobile so
 * the sidebar collapses to a drawer, master/detail screens stack instead of
 * sharing the viewport, and tables switch to horizontal-scroll mode.
 */
import { useEffect, useState } from 'react'

export const MOBILE_BREAKPOINT = 768

export function useViewportWidth(): number {
  const [width, setWidth] = useState(() => (typeof window === 'undefined' ? 1024 : window.innerWidth))
  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])
  return width
}

export function useIsMobile(): boolean {
  return useViewportWidth() < MOBILE_BREAKPOINT
}

/** Viewport height, for layouts that only fit a fixed-height pane on a tall
 *  enough screen (a phone held sideways is wide but short). */
export function useViewportHeight(): number {
  const [height, setHeight] = useState(() => (typeof window === 'undefined' ? 768 : window.innerHeight))
  useEffect(() => {
    const onResize = () => setHeight(window.innerHeight)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])
  return height
}
